var SIGNUP_TYPE = {
  agency: 'Bedriftsmedlemskap',
  studentandpractice: 'Student- og/eller praksismedlemskap',
  person: 'Personmedlemskap'
};

module.exports = SIGNUP_TYPE;
